// provider.reducer.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchAllProcedures } from '@store/actions/procedure.action'
import { Procedure } from '@dataTypes/appointment.type'

interface ProcedureState {
  data: Procedure[] | []
  loading: boolean
  error: string | null
}

const initialState: ProcedureState = {
  data: [],
  loading: false,
  error: null,
}

const proceduresSlice = createSlice({
  name: 'procedure',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Procedures
    builder
      .addCase(fetchAllProcedures.pending, (state) => {
        state.loading = true
        state.error = null
      })

      .addCase(
        fetchAllProcedures.fulfilled,
        (state, action: PayloadAction<Procedure[]>) => {
          state.data = action.payload
          state.loading = false
          state.error = null
        },
      )
      .addCase(fetchAllProcedures.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

    // Matcher
    builder.addMatcher(
      (action) =>
        action.type.startsWith('api/procedure/') &&
        action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      },
    )
    builder.addMatcher(
      (action) =>
        action.type.startsWith('api/procedure/') &&
        action.type.endsWith('/rejected'),
      (state) => {
        state.error = 'Failed to process request'
        state.loading = false
      },
    )
  },
})

export default proceduresSlice.reducer
